<template>
  <div class="player margin-between-section">
    <div class="row not-margin">
      <div class="col-md-12 container-info">
        <h1>{{ $t('admin.upload_player')}}</h1>
        <router-link to="/players">
          <img src="../assets/images/back.png" /> {{ $t('admin.back')}}
        </router-link>
      </div>
      <div class="col-md-12 container-info">
        <p>{{ $t('admin.title_archives_player')}} {{dataUser.firstName}} {{ $t('admin.title_archives_desc')}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class=" info-user">
        <div class="file-field">
          <p>{{ $t('admin.upload_video')}} </p>
          
          <div v-if="fileVideoEdit == true">
            <label for="uplVideo"><img src="../assets/images/film.png" />{{ $t('admin.add_video')}}</label>
            <input @change="processFile($event)" id="uplVideo" class="uplVideo" type="file" accept="video/*"><br>
            <label class="name-file">{{this.fileVideoName}}</label>
          </div>
          <div v-if="fileVideoEdit == false">
            <div class="in-f-ima">
              <label class="">{{videoInfo}}</label>
              <button class="closeH" v-on:click="openVideo">X</button>
            </div>
          </div>
        </div>
      </div>
      <br>
      <div class=" info-user">
        <div class="file-field">
          
          <p>{{ $t('admin.upload_img')}}</p>
          
          <div v-if="fileImgEdit == true">
            <label for="uplimage"><img src="../assets/images/image.png" />{{ $t('admin.add_img')}}</label>
            <input @change="processImg($event)"  id="uplimage" class="uplimage" type="file" accept="image/*"><br>
            <label class="name-file">{{this.usuarioName}}</label>
           </div>
          <div v-if="fileImgEdit == false">
            <div class="in-f-ima">
              <label class="">{{imgInfo}}</label>
              <button class="closeH" v-on:click="openImg">X</button>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="col-md-12 margin-between-section b">
      <button v-if="display" v-on:click="cancel" type="btn" class="btn btn-action ">{{ $t('admin.pass')}}</button>
      <button v-if="display" v-on:click="savePlayer" type="btn" class=" btn btn-action add-con">{{ $t('admin.complete')}}</button>
      <button v-if="displayS" v-on:click="closeEdit" type="btn" class="btn btn-action add-con">{{ $t('admin.final')}}</button>
    </div>
  </div>
</template>

<script>

import Player from '@/parse/models/Players';
import * as tus from "tus-js-client"
import { bus } from '../main'

export default {
  name: "player",
  components: {},
  data() {
    return {

      display: true,
      displayS: false,
      dataUser: [],
      id: this.$route.query.id,
      mediaIdD: null,

      fileVideo: null,
      fileImg: null,

      positionsPlayer: [],
      nombre: "",
      apellido: "",
      liga: "",
      equipo: "",
      league: "",
      fecha: "",
      altura: "",
      contacto: "",
      nacionalidad: "",
      pasaporte: "",
      pierna: "",
      fileVideoName: "",
      usuarioName: "",

      jsonDef: [
        { position: "cb", value: 1 },
        { position: "lb", value: 2 },
        { position: "rb", value: 3 },
        { position: "lwb", value: 4 },
        { position: "rwb", value: 5 },
      ],
      jsonMed: [
        { position: "dm", value: 6 },
        { position: "cm", value: 7 },
        { position: "am", value: 8 },
        { position: "lm", value: 9 },
        { position: "rm", value: 10 },
      ],
      jsonDel: [
        { position: "s", value: 11 }
      ],
      positionGK: false,
      positionCB: false,
      positionLB: false,
      positionRB: false,
      positionLWB: false,
      positionRWB: false,
      positionDM: false,
      positionLM: false,
      positionCM: false,
      positionRM: false,
      positionAM: false,
      positionS: false,

      //Edit
      fileVideoEdit: true,
      fileImgEdit: true,
      videoInfo: null,
      imgInfo: null
      
    };
  },

  beforeMount(){
    Player.loadInfoUnique(this.id)
      .then((user) => {
        this.dataUser = user
        
        if(user.avatar != undefined ){
          this.imgInfo = user.avatar
          this.fileImgEdit = false
        }

        if(user.video != undefined ){
          this.videoInfo = user.video
          this.fileVideoEdit = false
        }

        //console.log(user)
      })
      .catch(error => console.error(error))
  },
  created() {
    bus.$on("save", (value) => {
      this.save(value)
    });
  },
  methods: {

    openVideo(){
      this.fileVideoEdit = true
    },

    openImg(){
      this.fileImgEdit = true
    },

    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    position (item) {

//      this.positionGK = false,
      this.positionCB = false,
      this.positionLB = false,
      this.positionRB = false,
      this.positionLWB = false,
      this.positionRWB = false,
      this.positionDM = false,
      this.positionLM = false,
      this.positionCM = false,
      this.positionRM = false,
      this.positionAM = false,
      this.positionS = false
    

      switch (item) {
        
        case 1:
          //this.positionGK = true
          this.positionCB = true

          
          break;
        
        case 2:
          this.positionLB = true
          this.positionsPlayer.push('LB')
          break;
        
        case 3:
          this.positionRB = true
          break;

        case 4:
          this.positionLWB = true

          break;

        case 5:
          this.positionRWB = true
          
          break;

        case 6:
          this.positionDM = true
          break;

        case 7:
          this.positionLM = true
          break;

        case 8:
          this.positionCM = true
          break;

        case 9:
          this.positionRM = true
          break;

        case 10:
          this.positionAM = true
          break;

        case 11:
          this.positionS = true
          break;
      
        default:
          break;
      }
    },
    positionSelected(position){
      this.positionsPlayer.push(position)
    },
    processFile(){
      this.fileVideo = event.target.files[0]
      this.fileVideoName =  "Mi video"
    },
    processImg(){
      this.fileImg = event.target.files[0]
      this.usuarioName =  "Mi imagen"
    },

    savePlayer(){
      
      /*if(this.videoInfo != '' && this.imgInfo != ''){
        
        this.$router.push('/players')
        return
      }*/
      this.notification = {
        disable: false,
        sampleMessage: true,
        message: this.$t('admin.load_player_reel'),
        progressive: true
      }

      bus.$emit('upload', this.notification)

      const file =  this.fileVideo
      const options = {
        endpoint: "https://api.cloudflare.com/client/v4/accounts/975d6be8f0279bda14b4abdca6c5424e/stream",
        headers: {
          'X-Auth-Email': 'ruben@wearetorque.com',
          'X-Auth-Key': '33eda5169cc408d2afb947654bee6fe3e5552',
        },
        chunkSize: 5 * 1024 * 1024, // Cloudflare Stream requires a minimum chunk size of 5MB.
        resume: true,
        metadata: {
          filename: this.dataUser.id,
          filetype: "video/mp4",
          defaulttimestamppct: 0.5,
        },
        //uploadSize: size,
        onError: function (error) {
          throw `Este es el error: ${error}`;
        },
        onProgress: function (bytesUploaded, bytesTotal) {
          const percentage = (bytesUploaded / bytesTotal * 100).toFixed(2);
          //console.log(bytesUploaded, bytesTotal, percentage + "%");
          this.notification = {
            percentage: percentage,
          }
          bus.$emit('progressiveBar', this.notification)
        },
        onSuccess: function () {
          
          const index = upload.url.lastIndexOf("/") + 1; // eslint-disable-line
          const mediaId = upload.url.substr(index) // eslint-disable-line
          
          bus.$emit('closeUpload', mediaId)
        }
      };

      const upload = new tus.Upload(file, options);
      upload.start();
    },
    save(value){

      this.notification = {
        disable: false,
        sampleMessage: true,
        message: this.$t('admin.update_player_create')
      }
      this.notificationerror = {
        disable: false,
        sampleMessage: true,
        message: this.$t('notification.error')
      }
      const params = {
        video: value,
        file: this.fileImg,
        player: this.dataUser,
      }

      Player.saveDetail(params)
      .then((user) => this.removeActions())
      .catch(error => bus.$emit('sample', this.notificationerror))
      
    },
    
    cancel(){
      this.$router.push('/players')
    },

    closeEdit(){
      this.$router.push('/players')
    },
    removeActions(){
      bus.$emit('sample', this.notification)

      this.display = false,
      this.displayS = true
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.closeH {
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  padding: 0;
  margin: 0;
  border: 1px solid #000;
  border-radius: 20px;
  width: 20px;
  height: 20px;
  margin-right: -10px;
  margin-top: -10px;
}

.in-f-ima{
  position: relative;
  width: 80%;
}

.in-f-ima label{
  border: 1px solid #000;
  padding: 10px;
  width: 100%;
  overflow: hidden;
}



.name-file{
  font-size: 12px;
}

.info-user{
  margin-top: 5%;
  text-align: left;
  padding-right: 25px;
}

.info-user p{
  font-size: 12px;
  margin: 2% 0 5% 0;
}

.radio input{
  margin-right: 5px;
}

.f-l{
  float: left; 
}

.f-r{
  float: right; 
}

.custom-select {
  background: #fff url("../assets/images/arrow_down.png") no-repeat right .75rem center/8px 10px;
  border: 1px solid #000;
  border-radius: 0;
}

.custom-select:focus{
  border-color: #000;
  box-shadow: none
}

.custom-select option {
    font-weight: 123px;
}

.content-options{
  position: relative;
  width: 100%;
  text-align: left;
  margin-top: 20px;
}

.opt-radio{
  display: inline-block;
  width: 50%;
}


.title-value{
  font-size: 12px;
  display: block;
}

.radio + .radio {
  margin: 15px 0 0 0;
}

.radio, .checkbox {
  display: block;
  margin: 15px 0 0 0;
}

.radio label, .checkbox label{
  font-size: 11px;
  font-weight: 600;
  text-decoration: underline;
}


.margin-top-item{
  margin-top: 10% !important;
}


/* Position */

.lb-position{
  position: absolute;
  width: 81.5px;
  height: 50px;
  left: 7px;
  background: rgba(139, 139, 139, 0.24);
  top: 0;
  opacity: 0.6;
}

.cb-position{
  position: absolute;
  width: 81.5px;
  height: 75px;
  left: 7px;
  background: rgba(139, 139, 139, 0.24);
  top: 50px;
  opacity: 0.6;
}

.rb-position{
  position: absolute;
  width: 81.5px;
  height: 51px;
  left: 7px;
  background: rgba(139, 139, 139, 0.24);
  bottom: 0;
  opacity: 0.6;
}

.lwb-position{
  position: absolute;
  width: 91.5px;
  height: 50px;
  left: 89px;
  background: rgba(139, 139, 139, 0.24);
  top: 0;
  opacity: 0.6;
}

.rwb-position{
  position: absolute;
  width: 91.5px;
  height: 50px;
  left: 89px;
  background: rgba(139, 139, 139, 0.24);
  bottom: 0;
  opacity: 0.6;
}

.dm-position{
  position: absolute;
  width: 45px;
  height: 76px;
  left: 89px;
  background: rgba(139, 139, 139, 0.24);
  top: 50px;
  opacity: 0.6;
}

.lm-position{
  position: absolute;
  width: 81px;
  height: 50px;
  left: 181px;
  background: rgba(139, 139, 139, 0.24);
  top: 0;
  opacity: 0.6;
}

.cm-position{
  position: absolute;
  width: 44.5px;
  height: 76px;
  left: 136px;
  background: rgba(139, 139, 139, 0.24);
  top: 50px;
  opacity: 0.6;
}

.rm-position{
  position: absolute;
  width: 81px;
  height: 50px;
  left: 181px;
  background: rgba(139, 139, 139, 0.24);
  bottom: 0;
  opacity: 0.6;
}

.am-position{
  position: absolute;
  width: 45px;
  height: 76px;
  left: 181px;
  background: rgba(139, 139, 139, 0.24);
  top: 50px;
  opacity: 0.6;
}

.s-position{
  position: absolute;
  width: 35px;
  height: 76px;
  left: 227px;
  background: rgba(139, 139, 139, 0.24);
  top: 50px;
  opacity: 0.6;
}

.gk-map{
  position: absolute;
  width: 31px;
  height: 50px;
  left: 0px;
  background: green;
  top: 102px;
  opacity: 0.6;
}

.lat-i-map{
  position: absolute;
  width: 390px;
  height: 50px;
  left: 0;
  background: blue;
  top: 0;
  opacity: 0.6;
}

.lat-d-map{
  position: absolute;
  width: 390px;
  height: 50px;
  left: 0;
  background: red;
  bottom: 0;
  opacity: 0.6;
}

.def-map{
  position: absolute;
  width: 129px;
  height: 253px;
  left: 0;
  background: black;
  opacity: 0.6;
}

.med-map{
  position: absolute;
  width: 129px;
  height: 253px;
  margin-left: 130px;
  background: purple;
  opacity: 0.6;
}

.del-map{
  position: absolute;
  width: 129px;
  height: 253px;
  right: 0;
  background: orange;
  opacity: 0.6;
}


.map-area-container{
  background-color: #fff;
  width: 270px;
  height: 176px;
  position: relative;
  z-index: 1;
  margin-top: 10px;
  margin-left: 10px;
  display: inline-block;
}

.map-area{
  background: url(/img/camp.10dfa781.png)no-repeat;
  width: 270px;
  height: 176px;
  position: relative;
  background-size: 270px;
}

/* Position */

.btn {
  font-size: 12px;
}

.btn-action {
  display: inline-block;
  background: #fff;
  color: #000;
  border: 1px solid #000;
  font-size: 13px;
  font-family: "plain regular", arial;
  height: 35px;
  border-radius: 0;
  width: 250px;
}

.add-con {
  display: inline-block;
  background: #000;
  color: #fff;
  border: 1px solid #fff;
  font-size: 13px;
  font-family: "plain regular", arial;
  height: 35px;
  border-radius: 0;
  margin-left: 10%;
}

.add-con:hover {
  border: 1px solid #000;
  background: #fff;
  color: #000;
}


ul {
  text-decoration: none;
  list-style: none;
  margin: 0;
  padding: 0;
}

ul li {
  display: inline;
  margin-right: 10%;
}

.btn-position {
  font-size: 10px;
  border-bottom: 1px solid #000;
  width: 25px;
  padding: 0;
  margin-right: 5px;
  text-transform: uppercase;
  font-family: "plain medium", arial;
}

.margin-zero {
  margin: 0;
}
.padding-zero {
  padding: 0;
}

.c-header {
  width: 100%;
}

.info {
  text-align: left;
  width: 100%;
}

.info h1 {
  font-size: 20px;
  font-family: "plain regular", arial;
  display: inline-block;
  font-weight: bold;
}

.container-age {
  display: inline-block;
  margin: 7px;
}

.info h1 img {
  width: 20px;
  margin-right: 10px;
  margin-top: -8px;
}

.info p {
  font-size: 18px;
}

.container-info p {
  text-align: left;
  font-size: 14px;
  padding-top: 5%;
  font-family: "plain regular", arial;
}

.container-info {
  font-family: "plain regular", arial;
}

.container-info h1 {
  font-family: "plain regular", arial;
  float: left;
}

.container-info a {
  color: #000;
  font-family: "plain regular", arial;
  float: right;
  margin-right: 5px;
}

.container-info a img {
  width: 20px;
}

.not-margin {
  margin: 0;
}

.not-padding {
  padding: 0;
}

.group {
  margin-top: 3.5%;
}

.info-form-contact {
  text-align: left;
  font-size: 13px;
}

.info-form-contact label {
  margin-bottom: 0;
  font-size: 13px;
}

.input-form {
  border: 0;
  border-bottom: 1px solid #000;
  width: 80%;
  padding-bottom: 10px;
}

.con-i input {
  border: 0;
  border-bottom: 1px solid #000;
  width: 120px;
  font-size: 12px;
  margin-left: 5%;
}

.send-b {
  border: 1px solid #000;
  border-radius: 0;
  margin-left: 0px;
  font-size: 12px;
  padding: 5px 30px;
  margin-bottom: 9px;
}

.container-drop {
  text-align: center;
}


.dropdown {
  font-size: 13px;
  font-family: "plain regular", arial;
  height: 35px;
}

.dropdown-menu {
  border: 1px solid #000;
  border-radius: 0;
  margin: 0.125rem -1px 0;
}

.dropdown-toggle::after {
  margin-left: 5em;
}

.dropdown-btn {
  font-size: 13px;
}

.dropdown-item {
  font-size: 13px;
}

.instruction {
  color: #000;
  font-size: 11px !important;
  font-family: "plain regular", arial;
}

.instruction-position {
  color: rgb(138, 138, 138);
  font-size: 9px !important;
}

.camp-position {
  position: relative;
  display: block;
  margin-top: 7%;
}

.content-button-filter{
  display: inline-block;
  float: left;
  width: 50%;
}


.container-footer-drop {
  position: relative;
  margin: 7px;
}

.container-footer-drop img {
  width: 50%;
  margin-bottom: 5px;
}

.instruction-mapa {
  color: rgb(124, 124, 124);
  font-size: 9px !important;
  margin-left: 10px;
}

#uplimage {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
#uplVideo {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

label[for="uplimage"] {
  font-weight: 600;
  color: #000;
  border: 1px solid #000;
  background-color: #fff;
  display: inline-block;
  transition: all .5s;
  cursor: pointer;
  padding: 5px 40px !important;
  width: fit-content;
  text-align: center;
  font-size: 12px;
}

label[for="uplimage"] img{
  width: 18px;
  margin-right: 10px;
  font-size: 12px;
}

label[for="uplVideo"] {
  font-weight: 600;
  color: #000;
  border: 1px solid #000;
  background-color: #fff;
  display: inline-block;
  transition: all .5s;
  cursor: pointer;
  padding: 5px 40px !important;
  width: fit-content;
  text-align: center;
  font-size: 12px;
}

label[for="uplVideo"] img{
  width: 18px;
  margin-right: 10px;
  font-size: 12px;
}


/* Mobile first queries */

/* Larger than Desktop HD */
@media (max-width: 1200px) {}

/* Larger than desktop */
@media (max-width: 992px) {
  .custom-select {
    padding: .1rem .1rem .1rem .1rem;
  }

  .in-f-ima{
    width: 100%;
  }

}

/* Larger than tablet */
@media (max-width: 768px) {
  .content-button-filter{
    width: 100%;
  }
  .btn-action {
    width: 100%;
    margin: 5% 0;
  }
  .add-con {
    float: left;
    width: 100%;
    margin: 5% 0;
  }

  .b{
    overflow: hidden;
  }

}
/* Larger than phablet */
@media (max-width: 550px) {
}

/* Larger than mobile */
@media (max-width: 400px) {}

</style>
